export default "__VITE_ASSET__ed83a234__"